import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type CredentialsIconProps = {
  size?: number
  color?: string
  className?: string
}

export const CredentialsIcon = ({
  size = 16,
  color = tokenVar('colors.icon.secondary'),
  className,
}: CredentialsIconProps) => (
  <svg
    aria-label='Credentials'
    className={className}
    fill='none'
    height={size}
    role='img'
    viewBox='0 0 16 16'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M5.79488 9.0996L5.09088 14.4L7.99998 12.6546L10.909 14.4L10.205 9.09384M12.0727 5.67273C12.0727 7.92203 10.2493 9.74544 7.99998 9.74544C5.75067 9.74544 3.92725 7.92203 3.92725 5.67273C3.92725 3.42342 5.75067 1.6 7.99998 1.6C10.2493 1.6 12.0727 3.42342 12.0727 5.67273Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
  </svg>
)
